import{styled}from"styled-components";export const Icon=/*#__PURE__*/styled.svg.withConfig({componentId:"sc-1yu8hcz-0"})`flex-shrink:0;&[fill='none']{fill:none;}`;
//# sourceMappingURL=icon.styles.js.map